<template>
  <div class="d-flex items-center">
    <div class="account-subscription-tariff__description-list-item-icon">
      <BaseSvg
        :name="item.icon.name"
        :width="item.icon.width"
        :height="item.icon.height"
        class="mr-2"
      />
    </div>

    <div class="account-subscription-tariff__description-list-item-title">{{ item.title }}</div>

    <BaseTooltip
      v-if="item.description"
      :text="item.description"
      tooltip-menu-style="max-width: 27.6rem; text-align: left"
      class="account-subscription-tariff__description-list-item-tooltip"
    >
      <template v-slot:activator>
        <div class="account-subscription-tariff__description-list-item-tooltip-activator">?</div>
      </template>
    </BaseTooltip>
  </div>
</template>

<script>
export default {
  name: 'SubscriptionTariffDescriptionItem',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>
